module.exports = __webpack_public_path__ + "static/media/arrow_down_icon.dfb0aa87.svg";